module.exports = __webpack_public_path__ + "excel.79843ca.png";